import React from 'react';
import PropTypes from 'prop-types';
import { interviewAvailabilityShape } from '../../../../dateUtils';
import { isMobile } from '../../../../screenUtils';
import PastInterviewCard from './Cards/PastInterviewCard';
import UpcomingInterviewCard from './Cards/UpcomingInterviewCard';
import PendingInterviewCard from './Cards/PendingInterviewCard';
import RescheduleInterviewCard from './Cards/RescheduleInterviewCard';
import './InterviewCardOverlay.scss';

const typeToRenderer = {
  upcoming: UpcomingInterviewCard,
  pending: PendingInterviewCard,
  past: PastInterviewCard,
  reschedule: RescheduleInterviewCard,
};

const overlayCardShadow = '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.1)';

const overlayStyles = (style) => (
  isMobile()
    ? {
      ...style,
      backgroundColor: '#FFF',
      width: '100%',
      borderRadius: '4px',
      boxShadow: overlayCardShadow,
      zIndex: 999,
    }
    : {
      ...style,
      position: 'absolute',
      backgroundColor: '#FFF',
      top: 'auto',
      bottom: '0px',
      marginLeft: '7px',
      width: '400px',
      borderRadius: '4px',
      boxShadow: overlayCardShadow,
      zIndex: 999,
    }

);

function InterviewCardOverlay({
  className,
  style,
  interviewType,
  interview,
  possibleInterviewers,
  invitableRoles,
  onCancel,
  onSubmitMeetingDetails,
  canCancel,
  canEdit,
  consultantView,
  closeOverlay,
  isRep,
  csrfToken,
  editModalRef,
  repOrOwner,
  resheduleModalRef,
  newInterviewSlot,
  availableInterviewSlotUrl,
}) {
  return (
    <div
      className={className}
      style={overlayStyles(style)}
    >
      <div className="interview-card-header g-row--always g-row-justify-right" id={interviewType}>
        <a
          className="close-interview-card"
          onClick={closeOverlay}
          role="button"
          tabIndex="0"
        >
          <i className="fas fa-times" />
        </a>
      </div>
      <div className="style-guide interview-card-overlay">
        {typeToRenderer[interviewType]({
          interview,
          possibleInterviewers,
          invitableRoles,
          csrfToken,
          editModalRef,
          onCancel,
          onSubmitMeetingDetails,
          isRep,
          canCancel,
          canEdit,
          consultantView,
          repOrOwner,
          closeOverlay,
          resheduleModalRef,
          interviewType,
          newInterviewSlot,
          availableInterviewSlotUrl,
        })}
      </div>
    </div>
  );
}

InterviewCardOverlay.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  interviewType: PropTypes.string.isRequired,
  interview: PropTypes.shape({
    accepted_time: interviewAvailabilityShape,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string,
    }).isRequired,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    timezone: PropTypes.string.isRequired,
    round_number: PropTypes.number,
    id: PropTypes.number.isRequired,
    edit_interview_path: PropTypes.string,
    cancel_interview_path: PropTypes.string,
  }).isRequired,
  possibleInterviewers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  csrfToken: PropTypes.string.isRequired,
  editModalRef: PropTypes.func,
  resheduleModalRef: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmitMeetingDetails: PropTypes.func,
  canEdit: PropTypes.bool,
  canCancel: PropTypes.bool,
  consultantView: PropTypes.bool,
  closeOverlay: PropTypes.func,
  isRep: PropTypes.bool,
  repOrOwner: PropTypes.bool,
  newInterviewSlot: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired,
};

InterviewCardOverlay.defaultProps = {
  possibleInterviewers: [],
  invitableRoles: [],
  editModalRef: () => null,
  resheduleModalRef: () => null,
  onCancel: () => null,
  onSubmitMeetingDetails: () => null,
  closeOverlay: () => null,
  isRep: false,
  canEdit: false,
  canCancel: false,
  repOrOwner: false,
  consultantView: false,
  newInterviewSlot: false,
  className: '',
};

export default InterviewCardOverlay;
